// src/utils/formatters.js
// Helper centralizado para formatacao de dados

/**
 * Formata duracao em minutos para string legivel (ex: "2h 30m")
 * @param {number} minutes - Minutos totais
 * @returns {string} Duracao formatada
 */
export const formatDuration = (minutes) => {
  if (!minutes || minutes <= 0) return '0h 0m';
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  return `${hours}h ${mins}m`;
};

/**
 * Formata valor monetario de acordo com o idioma
 * @param {number} amount - Valor
 * @param {string} language - Idioma ('pt' ou 'en')
 * @returns {string} Valor formatado
 */
export const formatCurrency = (amount, language = 'pt') => {
  if (amount === null || amount === undefined) return '-';
  return new Intl.NumberFormat(language === 'pt' ? 'pt-BR' : 'en-NZ', {
    style: 'currency',
    currency: language === 'pt' ? 'BRL' : 'NZD'
  }).format(amount);
};

/**
 * Formata data com locale apropriado
 * @param {Date|string} date - Data
 * @param {string} language - Idioma ('pt' ou 'en')
 * @returns {string} Data formatada
 */
export const formatDateWithLocale = (date, language = 'pt') => {
  if (!date) return '-';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString(language === 'pt' ? 'pt-BR' : 'en-NZ');
};

/**
 * Formata data apenas (sem hora)
 * @param {Date|string} date - Data
 * @param {string} language - Idioma ('pt' ou 'en')
 * @returns {string} Data formatada
 */
export const formatDateOnly = (date, language = 'pt') => {
  if (!date) return '-';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString(language === 'pt' ? 'pt-BR' : 'en-NZ');
};

/**
 * Formata hora apenas
 * @param {Date|string} date - Data
 * @param {string} language - Idioma ('pt' ou 'en')
 * @returns {string} Hora formatada
 */
export const formatTimeOnly = (date, language = 'pt') => {
  if (!date) return '-';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString(language === 'pt' ? 'pt-BR' : 'en-NZ', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Formata distancia em km
 * @param {number} meters - Distancia em metros
 * @returns {string} Distancia formatada
 */
export const formatDistance = (meters) => {
  if (!meters || meters <= 0) return '0 km';
  const km = meters / 1000;
  return `${km.toFixed(1)} km`;
};
